import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { StaticText } from '../Api/StaticText';
import { Toast } from '../hooks/useToast';


export const fetchStaticTextThunk = createAsyncThunk(
    'staticText/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await StaticText.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const updateStaticTextThunk = createAsyncThunk(
    'staticText/update',
    async (data, { dispatch, getState }) => {
        Toast('Updating Data', 'loading', true);
        try {
            const { api_token } = getState().profile.data;
            const response = await StaticText.updateText({ data, api_token });
            dispatch(setValue(data));
            Toast(response.message, 'success', false);
            return response.data
        } catch (err) {
            Toast(err.message, 'error', false);
        }
    }
)

export const insertFaqThunk = createAsyncThunk(
    'faq/insert',
    async (data, { dispatch, getState }) => {
        Toast('Adding New Faq', 'loading', true);
        try {
            const { api_token } = getState().profile.data;
            const response = await StaticText.insertFaq({ data, api_token });
            Toast(response.message, 'success', false);
            dispatch(insertFaq(response.data));
            return response.data
        } catch (err) {
            Toast(err.message, 'error', false);
        }
    }
)

export const deleteFaqThunk = createAsyncThunk(
    'faq/delete',
    async (data, { dispatch, getState }) => {
        Toast('Deleting Faq', 'loading', true);
        try {
            const { api_token } = getState().profile.data;
            const response = await StaticText.deleteFaq({ data, api_token });
            Toast(response.message, 'success', false);
            dispatch(deleteFaq(data));
            return response.data
        } catch (err) {
            Toast(err.message, 'error', false);
        }
    }
)

export const updateFaqThunk = createAsyncThunk(
    'faq/update',
    async ({ data, setIsModal }, { dispatch, getState }) => {
        Toast('Updating Faq', 'loading', true);
        try {
            const { api_token } = getState().profile.data;
            const response = await StaticText.updateFaq({ data, api_token });
            Toast(response.message, 'success', false);
            setIsModal(false);
            dispatch(updateFaq(data));
            return response.data
        } catch (err) {
            Toast(err.message, 'error', false);
        }
    }
)


const initialState = {
    status: "pending",
    data: {},
}

export const staticTextSlice = createSlice({
    name: 'staticText',
    initialState,
    reducers: {
        resetState: () => {
            return initialState
        },
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        setValue: (state, actions) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    ...actions.payload

                }
            }
        },
        insertFaq: (state, actions) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    faqs: [
                        actions.payload,
                        ...state.data.faqs,

                    ]

                }
            }
        },
        deleteFaq: (state, actions) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    faqs: [...state.data.faqs.map(item => {
                        if (item.slug != actions.payload.faq_slug) {
                            return item
                        }
                    })].filter(Boolean)
                }
            }


        },
        updateFaq: (state, actions) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    faqs: [
                        ...state.data.faqs.map(item => {
                            if (item.slug === actions.payload.slug) {
                                return actions.payload;
                            }
                            else {
                                return item;
                            }
                        })

                    ]

                }
            }
        },
    },
    extraReducers: {
        [fetchStaticTextThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchStaticTextThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [fetchStaticTextThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [updateStaticTextThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [updateStaticTextThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [updateStaticTextThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [insertFaqThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [insertFaqThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [insertFaqThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [deleteFaqThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [deleteFaqThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [deleteFaqThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [updateFaqThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [updateFaqThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [updateFaqThunk.rejected]: (state, action) => {
            state.status = "error"
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, setValue, insertFaq, deleteFaq, updateFaq,resetState } = staticTextSlice.actions

export default staticTextSlice.reducer